/**
 * VelocityChangedContent - Renders content for VelocityChanged timeline events
 * Shows old and new velocity values with optional bucket info
 */

import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface VelocityChangedContentProps {
  event: TimelineEvent;
}

const VelocityChangedContent: React.FC<VelocityChangedContentProps> = ({ event }) => {
  const { t } = useTranslation();

  const oldVelocity = event.payload?.oldVelocity ?? '';
  const newVelocity = event.payload?.newVelocity ?? '';

  return (
    <div className="sphere-timeline-event__content-block">
      <p className="sphere-timeline-event__description">
        {t('activityFeed.events.velocityChanged.detail', {
          oldVelocity: String(oldVelocity),
          newVelocity: String(newVelocity),
        })}
      </p>
    </div>
  );
};

export default VelocityChangedContent;
